module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/babysitting-desktop-41d8af84d86b28c88b844a1edc7d5b8d.jpg";